import { parseFormula } from "@/lib/science/formula-parser";
import { ATOMIC_WEIGHT } from "@/lib/science/periodic-table";

export interface MwRow {
  element: string;
  count: number;
  atomicWeight: number;
  mass: number;
  percent: number;
}
export interface MwOk {
  ok: true;
  formula: string;
  molarMass: number;
  rows: MwRow[];
}
export interface MwErr {
  ok: false;
  error: string;
}
export type MwOutcome = MwOk | MwErr;

/** Molar mass + per-element mass breakdown from a chemical formula string. */
export function molecularWeight(input: string): MwOutcome {
  const parsed = parseFormula(input);
  if (!parsed.ok) return parsed;

  let total = 0;
  const rows: MwRow[] = [];
  for (const [element, count] of Object.entries(parsed.counts)) {
    const atomicWeight = ATOMIC_WEIGHT[element];
    const mass = atomicWeight * count;
    total += mass;
    rows.push({ element, count, atomicWeight, mass, percent: 0 });
  }

  for (const r of rows) r.percent = total > 0 ? (r.mass / total) * 100 : 0;
  rows.sort((a, b) => b.mass - a.mass);
  return { ok: true, formula: input.trim(), molarMass: total, rows };
}
